<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'page-working-environment',
	};
</script>



// WEBPACK FOOTER //
// src/pages/working-environment/page-working-environment.vue